function requireAll(r) { r.keys().forEach(r); }

requireAll( require.context( './ico/', true ) );
requireAll( require.context( './svg/', true, /\.svg$/) );
//requireAll( require.context( './png/', true, /\.png$/) );
//requireAll( require.context( './gif/', true, /\.gif$/) );
requireAll( require.context( './fonts/', true ) );
requireAll( require.context( './admin-thumbs/', true, /\.png$/) );

import { gsap, Linear } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";

import { NavDrag } from '../src/js/navdrag.js';
import { ToggleSection } from '../src/js/toggleSection.js';
import { Accordion } from '../src/js/accordion.js';
import { HideFilter } from '../src/js/hideFilter.js';


import $ from 'jquery';

window.jQuery = $;
window.$ = $;

import lottie from 'lottie-web';
import objectFitImages from 'object-fit-images';
import HappyFocus from 'happy-focus';
import Mustache from 'mustache';
import Headroom from 'headroom.js';
import ScrollReveal from 'scrollreveal';
import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';

gsap.registerPlugin( ScrollToPlugin );
gsap.registerPlugin( ScrollTrigger );

$(function () {

	var PROJECT = {

		common: {

			getViewport: function() {

				var viewPortWidth;
				var viewPortHeight;

				if (typeof window.innerWidth !== 'undefined') {

					viewPortWidth = window.innerWidth;
					viewPortHeight = window.innerHeight;

				} else if ( typeof document.documentElement !== 'undefined' &&
							typeof document.documentElement.clientWidth !== 'undefined' &&
							document.documentElement.clientWidth !== 0 ) {

					viewPortWidth = document.documentElement.clientWidth;
					viewPortHeight = document.documentElement.clientHeight;

				} else {

					viewPortWidth = document.getElementsByTagName('body')[0].clientWidth;
					viewPortHeight = document.getElementsByTagName('body')[0].clientHeight;
				}

				return { width : viewPortWidth , height : viewPortHeight };

			},

			init: function () {

				objectFitImages();

				const happyfocus = new HappyFocus();

				PROJECT.nav.init();
				PROJECT.navFooter.init();
				PROJECT.search.init();
				PROJECT.toggle.init();
				PROJECT.hero.init();
				PROJECT.video.init();
				PROJECT.image.init();
				PROJECT.lightbox.init();

				PROJECT.gform.init();
				PROJECT.overlay.init();
				//PROJECT.carousel.init();
				PROJECT.sliders.init();
				PROJECT.floatingCta.init();

				PROJECT.common.toggleInit();
				PROJECT.accordion.init();
				PROJECT.hotspot.init();
				PROJECT.list.init();

				PROJECT.scroll.init();

				PROJECT.header.init();

				PROJECT.lottie.init();

				PROJECT.stacking.init();

				PROJECT.agenda.init();
				
				window.tabsList.init({
					scrollToTop: false,
					callbacks: {

						afterAjaxCallback: function() { PROJECT.list.afterAjaxCallback() }

					}
				});

				PROJECT.eventTracking.init();

			},

			toggleInit: function () {

				$( document ).on( 'click', '.jsDownloadToggle', {

					class: 'v-download--open',
					classElement: '.jsDownload',
					navElement: '.jsDownloadDesc',

				}, PROJECT.common.toggle );

			},

			toggle: function ( e ) {

				e.preventDefault();

				var parent = $( this ).closest( e.data.classElement );

				if ( !$( parent ).hasClass( e.data.class ) ) {

					if ( typeof e.data.scrollFix !== 'undefined' && e.data.scrollFix === true ) {
						
						PROJECT.nav.headerSticky.freeze();

					}

					$( parent ).addClass( e.data.class );

					if ( e.data.navElement !== '' ) {

						$( parent ).find( e.data.navElement ).slideDown( 250 );

					}

				} else {

					if ( typeof e.data.scrollFix !== 'undefined' && e.data.scrollFix === true ) {
						
						PROJECT.nav.headerSticky.unfreeze();

					}

					$( parent ).removeClass( e.data.class );

					if ( e.data.navElement !== '' ) {

						$( parent ).find( e.data.navElement ).slideUp( 250 );

					}

				}

			}

		},

		eventTracking: {

			init: function() {

				$( document ).on( 'click.trackDownload', '.jsDownloadTracker', PROJECT.eventTracking.trackDownloadLink );

			},

			trackDownloadLink: function() {

				if (typeof dataLayer !== 'undefined') {

					var $thisLink = $(this);
					var link_url = $thisLink.attr('href');

					if ( link_url !== '' ) {

						var filename = link_url.split('/').pop();

						if ( filename !== '' ) {

							var downloadType = $thisLink.data('downloadType');

							if ( downloadType.trim() === '' ) {

								downloadType = 'unknown'

							}

							dataLayer.push({
								'event':		'file_download',
								'file_name':	filename,
								'link_url':		link_url,
								'download_type':downloadType
							});

						}

					}

				}

			}

		},

		cookie: {
			/**
			 * getCookie function.
			 *
			 * @access public
			 * @return string Return cookie value or null when cookie doesn't exists
			 */
			get: function(cookieName) {
				var nameEQ = cookieName + '=';
				var cookies = document.cookie.split(';');

				for (var i = 0; i < cookies.length; i++) {
					var cookie = cookies[i];

					while (cookie.charAt(0) === ' ') {
						cookie = cookie.substring(1,cookie.length);
					}

					if (cookie.indexOf(nameEQ) === 0) {
						return cookie.substring(nameEQ.length,cookie.length);
					}
				}

				return null;
			},

			/**
			 * setCookie function.
			 *
			 * @access public
			 * @return void
			 */
			set: function(cookieName,cookieValue,cookieDays) {
				var expires = "";
				if (typeof cookieDays !== 'undefined' && cookieDays !== null) {
					var date = new Date();
					date.setTime(date.getTime() + (cookieDays*24*60*60*1000));
					expires = "; expires=" + date.toUTCString();
				}
				document.cookie = cookieName + "=" + cookieValue + expires + "; path=/";
			},

			/**
			 * setCookie function.
			 *
			 * @access public
			 * @return void
			 */
			delete: function(cookieName) {
				document.cookie = cookieName + '=; Max-Age=-99999999;';
			}

		},

		toggle: {

			/*
			 * Toggle Text in Button label
			 * Used in jsnNavToggle
			 */

			clickElm: '.jsToggleText',
			labelElm: '.jsToggleTextLabel',
			dataAttr: 'toggle-text',

			init: function() {

				$( document ).on( 'click', PROJECT.toggle.clickElm, PROJECT.toggle.switch );

				$( document ).on( 'keyup', PROJECT.toggle.esc );

			},

			switch: function( e ) {

				PROJECT.toggle.doSwitch( $( this ) );

			},

			doSwitch: function( $elm ) {

				let $label = $elm.find( PROJECT.toggle.labelElm );

				let toggleText = $elm.data( PROJECT.toggle.dataAttr );

				let currentText = $label.text();

				let newText = currentText == toggleText.current ? toggleText.toggle : toggleText.current;

				$label.text( newText );

				$elm.attr( 'title', newText );

			},

			esc: function( e ) {

				if ( e.keyCode === 27 ) {
					
					$( PROJECT.toggle.clickElm ).each( function() {

						let $elm = $( this );

						let toggleText = $elm.data( PROJECT.toggle.dataAttr );
						let titleText = $elm.attr( 'title' );
						
						if ( toggleText.current == titleText ) {
	
							PROJECT.toggle.doSwitch( $( this ) );
	
						}

					});

				}

			},

			reset: function() {

				$( 'html' ).removeClass( PROJECT.nav.openClass );
				$( 'html' ).removeClass( PROJECT.search.openClass );
				$( 'html' ).removeClass( PROJECT.search.openClassSubmenu );

			}

		},

		nav: {

			/*
			 * Toggle Core Nav Visibility
			 * - Sets a css class on html elmement
			 * - Disable tabsindex when menu is closed
			 * - Click and Key controlled
			 */


			mainElm: '.navMain',
			clickElm: '.jsNavToggle',
			openClass: 'state-c-header--nav-open',
			openClassSubmenu: 'state-c-header--submenu-open',

			headerSticky: null,

			init: function() {

				$( document ).on( 'click', PROJECT.nav.clickElm, PROJECT.nav.toggle );
				$( document ).on( 'click', '.c-header__nav a[href^="#"]', PROJECT.nav.toggle );
			
				$( document ).on( 'mouseenter mouseover', '.v-nav--quick > .v-nav__item--has-children', PROJECT.nav.openSubmenu );
				$( document ).on( 'mouseleave', '.v-nav--quick > .v-nav__item--has-children', PROJECT.nav.closeSubmenu );

				$( document ).on( 'click', '.v-nav--quick a[href^="#"]', PROJECT.nav.closeSubmenuOnAnchor );

				$( document ).on( 'click', '.v-nav--toggle-top > .v-nav__item--has-children .jsNavItemToggle', PROJECT.nav.toggleSubmenu );

				$( document ).on( 'keyup', PROJECT.nav.esc );

				$( PROJECT.nav.mainElm + ' a' ).each( function() {

					$( this ).attr( 'tabindex', -1 );

				});

				PROJECT.nav.sticky();
				//PROJECT.nav.initSubmenuHoverOnLoad();

			},

			initSubmenuHoverOnLoad: function() {

				$( '.v-nav--quick .sub-menu').each( function() {

					var position = $( this ).position();
					var height = $( this ).innerHeight();
					
					var inViewport = position.top + height;

					if ( inViewport > 0 ) {

						$( 'html' ).addClass( PROJECT.nav.openClassSubmenu );

					}

				});
				
			},

			toggle: function() {

				if ( $( 'html' ).hasClass( PROJECT.nav.openClass ) ) {

					PROJECT.nav.close();

				} else {

					PROJECT.nav.open();
				}
			},

			esc: function( e ) {

				if ( e.keyCode === 27 ) {

					PROJECT.nav.close();

				}
				
			},

			open: function() {

				PROJECT.toggle.reset();

				$( 'html' ).addClass( PROJECT.nav.openClass );

				$( PROJECT.nav.mainElm + ' a').each( function() {

					$( this ).removeAttr( 'tabindex', -1 );

				});

			},

			close: function() {

				$( 'html' ).removeClass( PROJECT.nav.openClass );

				$( PROJECT.nav.mainElm  + ' a' ).each( function() {

					$( this ).attr( 'tabindex', -1 );

				});

			},

			closeSubmenu: function( e ) {
				
				$( 'html' ).removeClass( PROJECT.nav.openClassSubmenu );

			},

			closeSubmenuOnAnchor:function(e){

				const target = e.target;

				const parent = target.closest('.v-nav--quick');

				$( 'html' ).addClass( 'forceHide' );

				parent.style.pointerEvents = 'none';

				window.addEventListener("mousemove", (event) => {

					setTimeout(() => {

						parent.style.removeProperty('pointer-events');
						$( 'html' ).removeClass( 'forceHide' );

					},280);

				 },{ once: true });

				$( 'html' ).removeClass( PROJECT.nav.openClassSubmenu );

			},

			openSubmenu: function( e ) {

				PROJECT.toggle.reset();

				$( 'html' ).addClass( PROJECT.nav.openClassSubmenu );

			},

			toggleSubmenu: function( e ) {
				
				e.preventDefault();

				var $parentItem = $( this ).parent().parent();

				if ( $parentItem.hasClass( 'v-nav__item--submenu-open' ) ) {

					$parentItem.removeClass( 'v-nav__item--submenu-open' );
					$parentItem.find( '.sub-menu' ).slideUp( 250 );

				} else {

					var $openItems = $( '.v-nav__item--submenu-open' );
						$openItems.not( $parentItem ).removeClass( 'v-nav__item--submenu-open' )
						$openItems.not( $parentItem ).find( '.sub-menu' ).slideUp( 250 );

					$parentItem.addClass( 'v-nav__item--submenu-open' );
					$parentItem.find( '.sub-menu' ).slideDown( 250 );

				}

			},

			sticky: function() {
				
				var $header = $( 'body' );
				
				PROJECT.nav.headerSticky = new Headroom( $header.get( 0 ), {

					offset : 50,
					tolerance : 0,
					tolerance : {

						up : 5,
						down : 0

					},
					classes : {

						initial : "state-c-header--init",
						pinned : "state-c-header--pinned",
						unpinned : "state-c-header--unpinned",
						top : "state-c-header--top",
						notTop : "state-c-header--not-top",
						bottom : "state-c-header--bottom",
						notBottom : "state-c-header--not-bottom"

					}

				});

				PROJECT.nav.headerSticky.init();

			}

		},

		hero: {

			body: $( 'html' ),
			section: [],
			shapeOffsetTo: [600, 160],
			shapeOffsetStart: [],
			classDisableScroll : 'state-s-hero--animation-active',

			checkCookie: function() {
				
				var thisCookieValue = PROJECT.cookie.get( 'showHeroOpening' );

				if ( typeof thisCookieValue !== 'undefined' && ( thisCookieValue === 'false' || thisCookieValue === false ) ) {

					return false;

				} else {

					return true;

				}

			},

			setCookie: function() {
				
				PROJECT.cookie.set( 'showHeroOpening', false );

			},


			init: function() {

				PROJECT.hero.section = $('.jsHero');

				if ( PROJECT.hero.section.length > 0 ) {

					PROJECT.hero.handleIntroAnimation();
					PROJECT.hero.updateShapePostition();

					PROJECT.hero.handleScrollAnimation();
					$(window).on( 'resize.hero orientationchange.hero', PROJECT.hero.updateShapePostition );

				}

			},

			// Red intro animation
			handleIntroAnimation: function() {

				// Also do a session check, oid
				var doOpening = PROJECT.hero.checkCookie();

				if ( PROJECT.hero.section.hasClass( 's-hero--start-animation' ) ) {

					if ( doOpening === true ) {

						// Disable scroll
						window.scrollTo( 0, 0 );
						PROJECT.hero.body.addClass( PROJECT.hero.classDisableScroll );
						window.scrollTo( 0, 0 );

						PROJECT.hero.setCookie();

						setTimeout( function() {

							PROJECT.hero.section.addClass( 's-hero--do-animation' );

							setTimeout( function() {

								PROJECT.hero.section.addClass( 's-hero--end-animation' );

								// Enable scroll
								PROJECT.hero.body.removeClass( PROJECT.hero.classDisableScroll );

								setTimeout( function() {

									PROJECT.hero.section.removeClass( 's-hero--start-animation' );
									PROJECT.hero.section.removeClass( 's-hero--do-animation' );
									PROJECT.hero.section.removeClass( 's-hero--end-animation' );
			
								}, 800 );
		
							}, 1200 );

						}, 500 );

					} else {

						PROJECT.hero.section.removeClass( 's-hero--start-animation' );
						PROJECT.hero.section.removeClass( 's-hero--do-animation' );
						PROJECT.hero.section.removeClass( 's-hero--end-animation' );

					}

				}

			},

			// Calculate the animated position of the shape, based on the position of Brabant in the SVG.
			updateShapePostition: function() {

				var root		= document.documentElement;
				var $svgBrabant	= PROJECT.hero.section.find('.jsHeroSvgBrabant');
				var $background	= PROJECT.hero.section.find('.jsHeroBg');
				var $shape		= PROJECT.hero.section.find('.jsHeroBgShape');
				var bgPos		= $background.offset();
				var svgPos		= $svgBrabant.offset();

				var shapeOffset = {
					top: svgPos.top - bgPos.top,
					left: svgPos.left - bgPos.left
				};

				// Disabled because it doesn't work this way anymore
				//root.style.setProperty('--hero-shape-animate-top', shapeOffset.top + 'px' );
				//root.style.setProperty('--hero-shape-animate-left', shapeOffset.left + 'px' );

				PROJECT.hero.shapeOffsetTo = shapeOffset;

				// Also recalculate start position for shape
				$shape.removeAttr('style');
				PROJECT.hero.shapeOffsetStart = $shape.position();

			},
			
			// Handle the animation on scroll
			handleScrollAnimation: function() {

				var sizes = {
					xs: [ 1342, 700 ],
					sm: [ 1363, 711 ],
					md: [ 1363, 711 ],
					lg: [ 1917, 1000 ]
				};

				var scrollOffset		= 0;
				var scrollOffsetEnd		= 0;
				var $backgroundShape	= PROJECT.hero.section.find('.jsHeroBgShape');
				var $svgBrabant 		= PROJECT.hero.section.find('.jsHeroSvgBrabant');
				var shapeOffsetEnd		= $svgBrabant.offset();
				var shapeOpacity		= 1;

				$(window).off('scroll.hero mousewheel.hero');
				$(window).on('scroll.hero mousewheel.hero', function() {

					var viewPort			= PROJECT.common.getViewport();
					var top_of_screen		= $(window).scrollTop();
					var bottom_of_screen	= $(window).scrollTop() + window.innerHeight;
					var top_of_section		= PROJECT.hero.section.offset().top ;
					var bottom_of_section	= PROJECT.hero.section.offset().top + PROJECT.hero.section.outerHeight();
					var top_of_svg			= $svgBrabant.offset().top;

					var shapeSize	= sizes.xs;

					// Determine correct shape size based on breakpoint
					if ( viewPort.width >= 1280 ) {
						shapeSize = sizes.lg;
						//scrollOffset = 200;
						scrollOffsetEnd = 100;
					} else if ( viewPort.width >= 1024 ) {
						shapeSize = sizes.md;
						//scrollOffset = 50;
						//scrollOffsetEnd = 50;
					} else if ( viewPort.width >= 768 ) {
						shapeSize = sizes.sm;
						//scrollOffset = 50;
					} else {
						//scrollOffset = 50;
					}

					var startPos	= top_of_section + scrollOffset;
					var endPos		= (top_of_svg / 2 ) + scrollOffsetEnd;

					var shapeCalcSize = shapeSize;
					var shapeCalcPosition = PROJECT.hero.shapeOffsetStart;

					// calculate width & height
					if ( top_of_screen > startPos && top_of_screen < endPos ) {
						// Go update position based on scroll position

						var percentage = top_of_screen / endPos;
						var multiplier = ( 1 - (top_of_screen / endPos) );//startPos / ( top_of_screen );//bottom_of_screen / top_of_screen;

						if ( multiplier < 0.07 ) {
							multiplier = 0.07;
						}
						if ( multiplier > 1 ) {
							multiplier = 1;
						}
						if ( percentage > 1 ) {
							percentage = 1;
						}

						shapeCalcSize = [
							shapeSize[0] * multiplier,
							shapeSize[1] * multiplier
						];

						// Calculate position
						var positionDifference = {
							top: ( shapeOffsetEnd.top + 200 ) - PROJECT.hero.shapeOffsetStart.top,
							left: ( shapeOffsetEnd.left - 100 ) - PROJECT.hero.shapeOffsetStart.left
						};
						
						var positionMultiplier = percentage;

						shapeCalcPosition = {
							top: PROJECT.hero.shapeOffsetStart.top + ( positionDifference.top * positionMultiplier ),
							left: PROJECT.hero.shapeOffsetStart.left + ( positionDifference.left * positionMultiplier )
						};

						if ( shapeCalcPosition.top > shapeOffsetEnd.top ) {
							shapeCalcPosition.top = shapeOffsetEnd.top
						}
						if ( shapeCalcPosition.left > shapeOffsetEnd.left ) {
							shapeCalcPosition.left = shapeOffsetEnd.left
						}

						shapeOpacity = multiplier;

						var mapOpacity = positionMultiplier;
						if ( mapOpacity > 0.97 ) {
							mapOpacity = 1;
						} else if ( mapOpacity < 0.02 ) {
							mapOpacity = 0;
						}

						$svgBrabant.css( { opacity: mapOpacity } );
						

					} else if ( top_of_screen > endPos ) {

						// We are after animation, shape should be smallest (and no opacity)
						shapeCalcSize = [
							shapeSize[0] * 0.08,
							shapeSize[1] * 0.08
						];

						shapeCalcPosition = shapeOffsetEnd;
						shapeOpacity = 0;
						$svgBrabant.css( { opacity: 1 } );

					} else { //if ( top_of_screen < startPos ) {

						// We are before animation, shape should be full width
						shapeCalcSize = shapeSize;
						shapeCalcPosition = PROJECT.hero.shapeOffsetStart;
						shapeOpacity = 1;
						$svgBrabant.css( { opacity: 0 } );

					} 


					if ( shapeOpacity > 0.95 ) {
						shapeOpacity = 1;
					} else if ( shapeOpacity < 0.1 ) {
						shapeOpacity = 0;
					}

					// Update backgroundShape
					$backgroundShape.css( {
						width: shapeCalcSize[0] + 'px',
						height: shapeCalcSize[1] + 'px',
						top: shapeCalcPosition.top + 'px',
						left: shapeCalcPosition.left + 'px',
						transform: 'translateX(0)',
						opacity: shapeOpacity
					} );

				});
				
			}

		},

		search: {

			/*
			 * Toggle Core Nav Visibility
			 * - Sets a css class on html elmement
			 * - Click and Key controlled
			 */


			clickElm: '.jsSearchToggle',
			openClass: 'state-c-header--search-open',


			init: function() {

				$( document ).on( 'click', PROJECT.search.clickElm, PROJECT.search.toggle );

				$( document ).on( 'keyup', PROJECT.search.esc );

			},

			toggle: function() {

				if ( $( 'html' ).hasClass( PROJECT.search.openClass ) ) {

					PROJECT.search.close();

				} else {

					PROJECT.search.open();
				}
			},

			esc: function( e ) {

				if ( e.keyCode === 27 ) {

					PROJECT.search.close();

				}
			},

			open: function() {

				PROJECT.toggle.reset();
				
				$( 'html' ).addClass( PROJECT.search.openClass );

			},

			close: function() {

				$( 'html' ).removeClass( PROJECT.search.openClass );

			}

		},

		navFooter: {

			init: function() {

				$( document ).off( 'click.footerSub');
				$( document ).on( 'click.footerSub', '.jsNavFooter .v-nav__item--has-children', PROJECT.navFooter.toggle );

			},

			toggle: function( e ) {

				var $thisElm = $(this);
				var $thisClickedElm = $( e.target );

				if ( $thisElm.attr('id') === $thisClickedElm.attr('id') ) {

					if ( $thisElm.hasClass( 'v-nav__item--submenu-open' ) ) {

						$thisElm.removeClass( 'v-nav__item--submenu-open' )

					} else {

						$thisElm.addClass( 'v-nav__item--submenu-open' );
						// TODO: Should we close all other submenu's?

					}

				}

			}

		},

		gform: {

			init: function() {

				$( document ).on( 'gform_post_render', PROJECT.gform.hideLoader );

				$( document ).on( 'click.loader', '.gform_button', PROJECT.gform.showLoader );
				$( document ).on( 'click.loader', '.gform_next_button, .gform_previous_button', PROJECT.gform.showLoader );
				$( document ).on( 'submit', '.gform_wrapper form', PROJECT.gform.showLoader );

				$( document ).on( 'gform_page_loaded', PROJECT.gform.hideLoader );

				$( document ).on( 'gform_confirmation_loaded', PROJECT.gform.showConfirmation );
				$( document ).on( 'click.loader', '.gformCloseConfirmation', PROJECT.gform.hideConfirmation );

				$( document ).on( 'focus', 'input, textarea, select', function() {
					$( this ).parents( '.gfield' ).addClass( 'state--has-focus' );
				});

				$( document ).on( 'blur', 'input, textarea, select', function( e ) {
					if( !$(this).val() ) {
						$( this ).parents( '.gfield' ).removeClass( 'state--has-focus' );
					}
				});

				PROJECT.gform.fixHasFocus();

			},

			fixHasFocus: function() {

				$( 'input, textarea, select' ).each(function() {

					if( $(this).val() ) {
						$( this ).parents( '.gfield' ).addClass( 'state--has-focus' );
					}

				});

			},

			showLoader: function() {

				var $gformContainer = $(this).closest( '.gformContainer' );
				var $gformLoader = $gformContainer.find( '.gformLoader' );

				$gformLoader.fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideLoader: function() {

				$( '.gformLoader' ).fadeOut( 300 );
				PROJECT.overlay.checkSession(); 

			},

			showConfirmation: function() {

				$( '.gformConfirmation' ).fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideConfirmation: function() {

				$( '.gformConfirmation' ).fadeOut( 300 );

			}

		},

		floatingCta: {

			init: function() {

				PROJECT.floatingCta.hideOnScroll();
				
			},

			hideOnScroll: function( ) {

				var $floatingContact = $( '.jsFloatingCta' );
				var $footer = $('.jsCoreFooter');
				var $section = [];
				var offset = 100;
				var keepHidingAfterSection = true; // always true (by design)

				if ( $floatingContact.length > 0 ) {

					var sectionClass = $floatingContact.data('floatHide');

					if ( typeof sectionClass !== 'undefined' && sectionClass !== '' ) {

						$section = $('.' + sectionClass );

						if ( $section.is(':last-child') ) {

							keepHidingAfterSection = true;

						}

					}

				}

				$(window).off('scroll.floatingCta mousewheel.floatingCta');

				if ( $floatingContact.length > 0 && $footer.length > 0 ) {

					$(window).on('scroll.floatingCta mousewheel.floatingCta', function() {

						var top_of_screen = $(window).scrollTop();
						var bottom_of_screen = $(window).scrollTop() + window.innerHeight;

						var top_of_footer = $footer.offset().top + offset;

						if ( $section.length > 0 ) {
						
							var top_of_section = $section.offset().top + offset;
							var bottom_of_section = $section.offset().top + $section.outerHeight();

						}
					
						// Hide floatind CTA on downloads sections and footer
						if ( ( bottom_of_screen > top_of_footer ) || (  $section.length > 0 && (bottom_of_screen > top_of_section && bottom_of_screen < bottom_of_section) ) ) {

							$floatingContact.addClass('v-cta--hidden');

						} else {

							// TODO: we could write this a bit nicer/better
							if ( keepHidingAfterSection === true ) {

								if ( $section.length > 0 && bottom_of_screen > top_of_section ) {

									//Keep hiding

								} else {

									$floatingContact.removeClass('v-cta--hidden');

								}

							} else {

								$floatingContact.removeClass('v-cta--hidden');

							}

						}

					});

				}

			}

		},

		overlay: {

			triggerSelector: '.jsOverlayOpen',
			closeSelector: '.jsOverlayClose',
			backSelector: '.jsOverlayBack',
			overlaySelector: '.jsOverlay',
			contentSelector: '.jsOverlayContent',
			openClass: 'state-s-overlay--open',
			backButtonClass: 'state-s-overlay--back',

			downloadFormSubmitted: false,

			activeAjax: false,
			activeShowLoader: false,

			init: function() {

				$( document ).off( 'click.overlayClose' );
				$( document ).off( 'click.overlayOpen' );

				$( document ).on( 'click.overlayClose', PROJECT.overlay.closeSelector, PROJECT.overlay.closeHandler );
				$( document ).on( 'click.overlayOpen', PROJECT.overlay.triggerSelector, PROJECT.overlay.triggerHandler );

				$( document ).off( 'keyup.overlayClose', PROJECT.overlay.esc );
				$( document ).on( 'keyup.overlayClose', PROJECT.overlay.esc );

				// Load session info
				PROJECT.overlay.checkSession();

			},

			esc: function( e ) {

				if ( e.keyCode === 27 ) {

					PROJECT.overlay.close();

				}
				
			},

			triggerHandler: function( e ) {

				e.preventDefault();
				var $thisTrigger = $(this);
				var $thisOverlay = $thisTrigger.closest(PROJECT.overlay.overlaySelector);
				var overlayType = $thisTrigger.data('overlayType');
				var showOverlay = true;
				var backButtonData = false;

				if ( typeof overlayType !== 'undefined' && overlayType !== '' ) {

					var overlayBackType = $thisTrigger.data('overlayBackType');

					if ( typeof overlayBackType !== 'undefined' && overlayBackType !== '' ) {

						backButtonData = {
							type: overlayBackType,
							data: {}
						};

						var overlayBackFields = $thisTrigger.data('overlayBackFields');

						if ( typeof overlayBackFields !== 'undefined' && overlayBackFields !== '' ) {

							overlayBackFields = overlayBackFields.split( ',' );

							if ( overlayBackFields.length > 0 ) {

								overlayBackFields.forEach( function(item) {

									var itemValue = $thisTrigger.data(item);
									backButtonData.data[item] = itemValue;

								});

							}

						}

					}
					

					switch(overlayType) {

						case 'downloads':

							var overlayDownloads = $thisTrigger.data('downloads');

							if ( typeof overlayDownloads !== 'undefined' && overlayDownloads !== '' ) {

								var data = {
									downloads: overlayDownloads
								};
								PROJECT.overlay.loadAjaxContent( 'get_downloads', data, $thisOverlay );

							}
							
							break;


						case 'download':

							// Determine if there should be a form shown, of direct download
							
							var overlayDownload = $thisTrigger.data('download');

							if ( typeof overlayDownload !== 'undefined' && overlayDownload !== '' ) {

								if ( PROJECT.overlay.downloadFormSubmitted === true ) {

									showOverlay = false;
									PROJECT.overlay.getDownloadFile( overlayDownload );

								} else {

									var data = {
										download: overlayDownload
									};
									PROJECT.overlay.loadAjaxContent( 'get_download', data, $thisOverlay );

								}

							}

							break;


						case 'form':
							
							var overlayForm = $thisTrigger.data('form');

							if ( typeof overlayForm !== 'undefined' && overlayForm !== '' ) {

								var data = {
									form: overlayForm
								};
								PROJECT.overlay.loadAjaxContent( 'get_form', data, $thisOverlay );

							}

							break;


						case 'contact':
							
							var overlayContact = $thisTrigger.data('contact');

							if ( typeof overlayContact !== 'undefined' && overlayContact !== '' ) {

								var data = {
									contact: overlayContact
								};
								PROJECT.overlay.loadAjaxContent( 'get_contact', data, $thisOverlay );

							}

							break;
							

						default:
							// nothing at the moment

					}

				}

				if ( showOverlay === true ) {

					PROJECT.overlay.open( backButtonData );

				}

			},

			closeHandler: function( e ) {

				e.preventDefault();
				PROJECT.overlay.close();

			},


			open: function( backButton ) {

				$( 'html' ).removeClass( PROJECT.overlay.backButtonClass );

				if ( backButton !== false ) {

					PROJECT.overlay.updateBackButton(backButton);
					$( 'html' ).addClass( PROJECT.overlay.backButtonClass );

				}

				$( 'html' ).addClass( PROJECT.overlay.openClass );

			},

			close: function() {

				$( 'html' ).removeClass( PROJECT.overlay.backButtonClass );
				$( 'html' ).removeClass( PROJECT.overlay.openClass );

			},

			loadAjaxContent: function( action, data, $overlay ) {

				if ( typeof action !== 'undefined' && action.length > 0 ) {

					if ( typeof $overlay === 'undefined' || $overlay.length === 0 ) {
						$overlay = $(PROJECT.overlay.overlaySelector);
					}

					PROJECT.overlay.activeShowLoader = setTimeout(function() {
						PROJECT.overlay.showLoader( $overlay );
					}, 500);
					
					var $overlayContent = $overlay.find( PROJECT.overlay.contentSelector );
					$overlayContent.html('');

					var formData = {};

					if ( typeof data !== 'undefined' ) {
						formData = data;
					}

					PROJECT.overlay.activeAjax = $.ajax({
						type: "GET",
						url: ajax_object.ajaxurl + '?action=' + action,
						data: formData,
						success: function(returnData) {

							$overlayContent.html( returnData.html );
							PROJECT.overlay.hideLoader($overlay);

						},
						error: function(returnData) {

							// Some error in ajax call
							PROJECT.overlay.hideLoader($overlay);

						}
					});

				}

			},

			loadForm: function() {
				// Maybe just use loadAjaxContent
			},

			showLoader: function( $overlay ) {

				if ( typeof $overlay === 'undefined' || $overlay.length === 0 ) {
					$overlay = $(PROJECT.overlay.overlaySelector);
				}

				$overlay.addClass( 's-overlay--loading' );
				clearTimeout(PROJECT.overlay.activeShowLoader);

			},

			hideLoader: function( $overlay ) {

				if ( typeof $overlay === 'undefined' || $overlay.length === 0 ) {
					$overlay = $(PROJECT.overlay.overlaySelector);
				}

				if (PROJECT.overlay.activeShowLoader) {
					clearTimeout(PROJECT.overlay.activeShowLoader);
				}

				$overlay.removeClass( 's-overlay--loading' );

			},

			updateBackButton: function( config ) {

				var $backButton = $( PROJECT.overlay.backSelector );
				$backButton.attr( 'data-overlay-type', config.type );

				for ( const key in config.data ) {

					$backButton.attr( 'data-' + key, config.data[key] );

				}

			},

			getDownloadFile: function( downloadId ) {

				if ( typeof downloadId !== 'undefined' ) {

					window.open( ajax_object.ajaxurl + '?action=get_download_file&download=' + downloadId );

					// Custom Google Event tracking
					if (typeof dataLayer !== 'undefined') {

						var googleTrackingAjax = $.ajax({
							url: ajax_object.ajaxurl + '?action=get_download_file',
							data: {
								download: downloadId,
								only_info: true
							},
							success: function(returnData) {

								if ( typeof returnData !== 'undefined' ) {

									dataLayer.push({
										'event':		'file_download',
										'file_name':	returnData.filename,
										'link_url':		returnData.link_url,
										'download_type':'second_download'
									});

								}

							},
							error: function() {
								// Just ignore it
							}
						});

					}

				}

			},

			checkSession: function( ) {

				PROJECT.overlay.activeAjax = $.ajax({
					type: "GET",
					url: ajax_object.ajaxurl + '?action=get_download_session',
					data: {},
					success: function(returnData) {

						if ( typeof returnData.session !== 'undefined' && returnData.session === true ) {

							PROJECT.overlay.downloadFormSubmitted = true;

						}

					},
					error: function(returnData) {

						// Some error in ajax call

					}
				});

			},

		},

		list: {

			init: function () {

				$( document ).on( 'click', '.tabsListSearchClear', PROJECT.list.searchClear );
				$( document ).on( 'keyup.clear change focus', '.tabsListSearchInput', PROJECT.list.searchClearAvailable );

				PROJECT.list.searchClearInit();

				$( document ).on( 'change', '.tabsListFilter', PROJECT.list.toggleFeature );

			},

			toggleFeature: function( e ) {

				// PROJECT.list.hideFeatured();

			},

			searchClearInit: function() {

				$( '.tabsListSearchInput' ).each( function() {

					PROJECT.list.searchClearDoCheck( this );

				});

			},

			searchClearAvailable: function ( e ) {

				PROJECT.list.searchClearDoCheck( this );

				// PROJECT.list.hideFeatured();


			},

			searchClearDoCheck: function ( element ) {

				var $searchElement = $( element ).closest( '.tabsListFilterSearch' );

				var searchValue = $( element ).val();

				if ( searchValue.length > 0 ) {

					$searchElement.addClass( 'v-list-filter--clear-available' );

				} else {

					$searchElement.removeClass( 'v-list-filter--clear-available' );

				}

			},

			searchClear: function( e ) {

				var $searchElement = $( this ).closest( '.tabsListFilterSearch' );

				$searchElement.find( 'input' ).val( '' ).trigger( 'change' );

				var $form = $searchElement.closest('form');
				
				$form.trigger('submit');

			} ,

			hideFeatured: function( afterAll ) {

				var hide = false;

				var filters = document.querySelectorAll(".s-list__filter");

				filters.forEach(function(el, index) { 

					var selectField = el.querySelectorAll('select');
					var inputField = el.querySelectorAll('input');

					if( selectField.length > 0 ) {

						if( selectField[0].value !== '' ) {

							hide = true;

						}

					}

					if( inputField.length > 0 ) {

						if( inputField[0].value !== '' ) {

							hide = true;

						}

					}

				});

				if(hide === true) {

					$( '.jsListFeatured' ).addClass('s-list__featured--hidden');
					$(".jsListFeatured").slideUp({
						duration: 400,
						complete: function() {

							if(  typeof afterAll !== 'undefined' && typeof afterAll === 'function' ) {

								afterAll();
			
							}

						}
					})

				}else {

					$( '.jsListFeatured' ).removeClass('s-list__featured--hidden');

					$(".jsListFeatured").slideDown({
						duration: 400,
					})

				}

			},

			afterAjaxCallback : function() {

				var tabsListElm = $('.tabsList');
				if( tabsListElm.length > 0 ) {

					PROJECT.list.hideFeatured( PROJECT.list.scrollToList );

				}

			},

			scrollToList : function() {

				var queryString = window.location.search;
				var urlParams = new URLSearchParams(queryString);
				var tabsListElm = $('.tabsList');
				var tabsListFeaturedElm = $('.s-list__featured');
				var scrollPosition = tabsListElm.offset().top - 70;

				if( urlParams.has('paging') === false ) {

					$('html, body').animate({ scrollTop: scrollPosition }, 600, 'linear' );

				}

			}
			
		},

		video : {

			init: function () {

				$( document ).on( 'click.videoOpen', '.jsVideoOpen', PROJECT.video.open );

			},

			open: function( e ) {

				e.preventDefault();

				var src = $( this ).data( 'video' ) + '&autoplay=true&fun=false&playsinline=true&controls=true';
				var style = $( this ).data( 'video-ratio' );
				var button = $( this ).data( 'template-button' );
				var caption = $( this ).data( 'video-caption' );
				var template = $( this ).data( 'template' );

				var cssClass = 'v-lightbox--video';

				if ( style != '' ) {

					style = 'padding-top: ' + style + '%';

				}

				var html = '<div class="v-lightbox__box lightboxBox" style="' + style + '"><iframe src="' + src + '" allow="autoplay"></iframe></div>';
				
				if ( typeof caption != 'undefined' && caption != '' ) {
					
					html += '<div class="v-lightbox__caption">' + caption + '</div>';

				}

				var data = {
					
					html: html,
					class: cssClass,
					button: button

				};

				PROJECT.lightbox.open( data, template );

			}

		},

		image : {

			init: function () {

				$( document ).on( 'click.imageModalOpen', '.jsImageModalOpen', PROJECT.image.open );

			},

			open: function( e ) {

				e.preventDefault();

				var src = $( this ).data( 'image' );// + '&autoplay=true&fun=false&playsinline=true&controls=true';
				// var style = $( this ).data( 'video-ratio' );
				var button = $( this ).data( 'template-button' );
				var caption = $( this ).data( 'video-caption' );
				var template = $( this ).data( 'template' );

				var cssClass = 'v-lightbox--image';

				// if ( style != '' ) {

				// 	style = 'padding-top: ' + style + '%';

				// }

				var html = '<div class="v-lightbox__box lightboxBox"><img src="' + src + '" ></div>';
				
				if ( typeof caption != 'undefined' && caption != '' ) {
					
					html += '<div class="v-lightbox__caption">' + caption + '</div>';

				}

				var data = {
					
					html: html,
					class: cssClass,
					button: button

				};

				PROJECT.lightbox.open( data, template );

			}

		},

		lightbox : {

			init: function() {

				$( document ).on( 'click', 'body', PROJECT.lightbox.outerClose );

				$( document ).on( 'click', '.lightboxClose', PROJECT.lightbox.close );

			},

			open: function( data, template, after ) {
				
				$.get( template, function( template ) {

					var templateRendered = Mustache.render( template, data );

					var $lightbox = $( $.parseHTML( templateRendered ) );
						$lightbox.hide();

					$( 'body' ).append( $lightbox );

					$lightbox.css( 'display', 'flex').hide().fadeIn( 300 );

					if ( typeof after == "function") {

						after( $lightbox );

					}

				});

			},

			close: function( e ) {

				$( '.lightboxElement' ).fadeOut( 300, function() {

					$( this ).remove();

				});

			},

			outerClose: function( e ) {

				var search_box = $( '.lightboxBox' );

				if ( !search_box.is(e.target) && search_box.has(e.target).length === 0 ) {

					PROJECT.lightbox.close();

				}

			}

		},
		
		sliders: {

			sliderObjects: [],

			init: function() {

				PROJECT.sliders.initPostCarousel();
				PROJECT.sliders.initNumbersCarousel();
				PROJECT.sliders.initLogoCarousel();
				PROJECT.sliders.initBlockCarousel();
				PROJECT.sliders.initHighlightCarousel();
				PROJECT.sliders.initImageCarousel();
				PROJECT.sliders.initSpeakersCarousel();

			},

			initPostCarousel: function() {

				$( '.jsPostCarouselSection' ).each( function() {
					
					var $thisSection = $( this );
					
					var $carouselWrapper = $thisSection.find('.jsPostCarousel');
					var carouselID = $thisSection.data( 'object' );

					var $carouselNext = $thisSection.find('.jsPostCarouselDrag');
					
					var postSwiper = new Swiper( $carouselWrapper.get( 0 ), {

						modules: [Navigation, Pagination],
					
						slidesPerView: 1,
						
						spaceBetween: 16,

						allowSlideNext: true,

						/* navigation: {
							
							lockClass: 's-post-carousel__drag--locked',
							disabledClass: 's-post-carousel__drag--disabled',
							
							nextEl: $carouselNext.get( 0 ),
							
						}, */

						breakpoints: {
							
							768: {
								
								slidesPerView: 2,

							},
							
							1024: {
								
								slidesPerView: 3,
								spaceBetween: 20,

							},
							
							1280: {
								
								slidesPerView: 3,
								spaceBetween: 30,
						
							}

						}

					});

					postSwiper.on( 'slideChange sliderFirstMove sliderMove', function () {

						$carouselNext.fadeOut( 250, function() {

							$( this ).remove();

						});

					});
					
					if ( carouselID == '' || typeof carouselID === undefined ) {
					
						var objectID = PROJECT.sliders.sliderObjects.push( postSwiper );
						
						$carouselWrapper.data( 'object', objectID );
						
					}
				
				});

			},

			initNumbersCarousel: function() {

				$( '.jsNumberCarouselSection' ).each( function() {
					
					var $thisSection = $( this );
					
					var $carouselWrapper = $thisSection.find( '.jsNumberCarousel' );
					var carouselID = $thisSection.data( 'object' );

					var $carouselBullets = $thisSection.find( '.jsNumberCarouselBullets' );
					
					var autoplay = $carouselWrapper.data( 'autoplay' )
					
					var numberSwiperArgs = {

						modules: [Autoplay,Pagination],

						slidesPerView: 1.5,

						spaceBetween: 0,

						pagination: {

							clickable:true,
							el: $carouselBullets.get( 0 ),
							type: 'bullets'

						},

						breakpoints: {

							568: {

								slidesPerView: 2

							},

							768: {

								slidesPerView: 3

							},

							1024: {

								slidesPerView: 4,
								spaceBetween: 20

							},
							
							1280: {
								
								slidesPerView: 4,
								spaceBetween: 0,
						
							}
						}

					};

					if ( autoplay === true ) {

						numberSwiperArgs.autoplay = {

							delay: 3000

						}

						numberSwiperArgs.loop = true;
						numberSwiperArgs.pagination = false;

					}

					var numberSwiper = new Swiper( $carouselWrapper.get( 0 ), numberSwiperArgs );
					
					if ( carouselID == '' || typeof carouselID === undefined ) {
					
						var objectID = PROJECT.sliders.sliderObjects.push( numberSwiper );
						
						$carouselWrapper.data( 'object', objectID );
						
					}
				
				});

			},

			initLogoCarousel: function() {

				$( '.jsLogoCarouselSection' ).each( function() {
					
					var $thisSection = $( this );
					
					var $carouselWrapper = $thisSection.find( '.jsLogoCarousel' );
					var carouselID = $thisSection.data( 'object' );
					
					var logoSwiper = new Swiper( $carouselWrapper.get( 0 ), {

						modules: [Autoplay],

						slidesPerView: 1,

						spaceBetween: 16,

						loop: true,

						watchOverflow: true,

						simulateTouch: false,

						autoplay: {

							delay: 2500,

						},

						breakpoints: {
							
							768: {

								slidesPerView: 2,

							},

							1024: {

								slidesPerView: 3,

								spaceBetween: 20

							},
							
							1280: {

								slidesPerView: 4,

								spaceBetween: 30

							}

						}

					});
					
					if ( carouselID == '' || typeof carouselID === undefined ) {
					
						var objectID = PROJECT.sliders.sliderObjects.push( logoSwiper );
						
						$carouselWrapper.data( 'object', objectID );
						
					}
				
				});

			},

			initBlockCarousel: function() {

				$( '.jsBlockCarouselSection' ).each( function() {
					
					var $thisSection = $( this );
					
					var $carouselWrapper = $thisSection.find('.jsCarousel');
					var carouselID = $thisSection.data( 'object' );

					var $carouselNext = $thisSection.find('.jsCarouselDrag');
					
					var postSwiper = new Swiper( $carouselWrapper.get( 0 ), {

						modules: [Navigation, Pagination],
					
						slidesPerView: 1,
						
						spaceBetween: 16,

						allowSlideNext: true,

						breakpoints: {
							
							768: {
								
								slidesPerView: 2,

							},
							
							1024: {
								
								slidesPerView: 3,
								spaceBetween: 20,

							},
							
							1280: {
								
								slidesPerView: 3,
								spaceBetween: 30,
						
							}

						}

					});

					postSwiper.on( 'slideChange sliderFirstMove sliderMove', function () {

						$carouselNext.fadeOut( 250, function() {

							$( this ).remove();

						});

					});
					
					if ( carouselID == '' || typeof carouselID === undefined ) {
					
						var objectID = PROJECT.sliders.sliderObjects.push( postSwiper );
						
						$carouselWrapper.data( 'object', objectID );
						
					}
				
				});

			},

			initHighlightCarousel: function() {

				$( '.jsHighlightCarouselView' ).each( function() {
					
					var $thisView = $( this );

					var $carouselWrapper = $thisView.find( '.jsHighlightCarousel' );
					var carouselID = $thisView.data( 'object' );
					var $carouselBullets = $thisView.find( '.jsHighlightCarouselBullets' );

					var $carouselNext = $thisView.find('.jsHighlightCarouselDrag');
					
					var highlightSwiperArgs = {
						modules: [Pagination],

						slidesPerView: 1,
						spaceBetween: 0,
						pagination: {

							clickable:true,
							el: $carouselBullets.get( 0 ),
							type: 'bullets'

						}
					};

					var highlightSwiper = new Swiper( $carouselWrapper.get( 0 ), highlightSwiperArgs );

					highlightSwiper.on( 'slideChange sliderFirstMove sliderMove', function () {

						$carouselNext.fadeOut( 250, function() {

							$( this ).remove();

						});

					});
					
					if ( carouselID == '' || typeof carouselID === undefined ) {
					
						var objectID = PROJECT.sliders.sliderObjects.push( numberSwiper );
						$carouselWrapper.data( 'object', objectID );
						
					}
				
				});

			},

			initImageCarousel: function() {

				$( '.jsImageCarouselSection' ).each( function() {
					
					var $thisSection = $( this );
					
					var $carouselWrapper = $thisSection.find( '.jsImageCarousel' );

					var slides = $carouselWrapper.find( '.swiper-slide' );

					var carouselID = $thisSection.data( 'object' );

					let buttonPrev = $thisSection.find('.jsCarouselPrev');
					let buttonNext = $thisSection.find('.jsCarouselNext');

					console.log( buttonPrev );
					console.log( buttonNext );
					
					var logoSwiper = new Swiper( $carouselWrapper.get( 0 ), {

						modules: [Navigation],

						slidesPerView: 1,

						spaceBetween: 16,

						loop: true,

						watchOverflow: true,

						centeredSlides: true,

						loopedSlides: slides.length,

						navigation: {
							nextEl: buttonNext[0],
							prevEl: buttonPrev[0],
						},


					});
					
					if ( carouselID == '' || typeof carouselID === undefined ) {
					
						var objectID = PROJECT.sliders.sliderObjects.push( logoSwiper );
						
						$carouselWrapper.data( 'object', objectID );
						
					}
				
				});

			},

			initSpeakersCarousel: function() {

				$( '.jsSpeakersCarousel' ).each( function() {
					
					var $thisSection = $( this );
					
					var $carouselWrapper = $thisSection.find('.jsCarousel');
					var carouselID = $thisSection.data( 'object' );

					var $carouselNext = $thisSection.find('.jsCarouselDrag');
					
					var postSwiper = new Swiper( $carouselWrapper.get( 0 ), {

						modules: [Navigation, Pagination],
					
						slidesPerView: 1,
						
						spaceBetween: 16,

						allowSlideNext: true,

						breakpoints: {
							
							768: {
								
								slidesPerView: 2,

							},
							
							1024: {
								
								slidesPerView: 3,
								spaceBetween: 20,

							},
							
							1280: {
								
								slidesPerView: 3,
								spaceBetween: 30,
						
							}

						}

					});

					postSwiper.on( 'slideChange sliderFirstMove sliderMove', function () {

						$carouselNext.fadeOut( 250, function() {

							$( this ).remove();

						});

					});
					
					if ( carouselID == '' || typeof carouselID === undefined ) {
					
						var objectID = PROJECT.sliders.sliderObjects.push( postSwiper );
						
						$carouselWrapper.data( 'object', objectID );
						
					}
				
				});

			},

		},

		accordion: {

			init: function() {

				$( document ).off( 'click', '.jsAccordionTitle');
				$( document ).on( 'click', '.jsAccordionTitle', {

					class: 'jsAccordionOpen',
					classElement: '.jsAccordion',
					toggleElement: '.jsAccordionText',

				}, PROJECT.accordion.toggle );

			},

			toggle: function ( e ) {

				e.preventDefault();

				var parent = $( this ).closest( e.data.classElement );

				if ( !$( parent ).hasClass( e.data.class ) ) {

					$( parent ).addClass( e.data.class );
					
					var openItems = $( '.' + e.data.class ).not( $( parent ) );

					openItems.removeClass( e.data.class );
					
					if ( e.data.toggleElement !== '' ) {
						
						openItems.find( e.data.toggleElement ).slideUp( 250 );

						$( parent ).find( e.data.toggleElement ).slideDown( 250 );

					}

				} else {

					$( parent ).removeClass( e.data.class );

					if ( e.data.toggleElement !== '' ) {

						$( parent ).find( e.data.toggleElement ).slideUp( 250 );

					}

				}

			},

		},

		hotspot: {

			init: function() {

				$( document ).on( 'click', '.jsHotspotOpen', PROJECT.hotspot.toggleHotspot );

				$( document ).on( 'click', '.jsHotspotBox', function(e) {

					e.stopPropagation();
				});
				
			},

			toggleHotspot: function( e ) {

				if ( $( this ).hasClass( 'v-hotspots__point--open' ) ) {
					
					$( this ).removeClass( 'v-hotspots__point--open' );

					$( this ).find( '.jsHotspotBox' ).css({ 'left' : '', 'right' : '' });

				} else {

					$( '.v-hotspots__point--open' ).removeClass( 'v-hotspots__point--open' );

					$( this ).addClass( 'v-hotspots__point--open' );

					var popup = $( this ).find( '.jsHotspotBox' );

					var pos = popup.offset();
					var width = popup.innerWidth();

					var viewport = PROJECT.common.getViewport();

					var posLeft = pos.left;
					var posRight = viewport.width - ( pos.left + width );

					
					if ( posLeft < 30 ) {

						$( popup ).css({

							left: 0

						});

					} else if ( posRight < 30 ) {

						var currentPos = $( popup ).position();

						if ( posRight < 0 ) {

							posRight = posRight * -1;

						}
						
						posRight = posRight + 30;

						var newPos = currentPos.left - posRight;

						if( newPos > 0 ) {

							newPos = 0;

						}

						$( popup ).css({

							left: newPos

						});

					}

				}

			}

		},

		scroll: {

			sr: null,

			init: function() {

				PROJECT.scroll.addHorzCards();

				PROJECT.scroll.scrollReveal();

				ScrollTrigger.refresh( true);

			},

			scrollReveal: function() {

				PROJECT.scroll.sr = new ScrollReveal({

					scale:	1,
					viewFactor: 0.25,
					duration: 400,
					delay: 100,
					distance: '60px',
					easing: 'ease-out'

				});

				PROJECT.scroll.sr.reveal( '.revealFromBottom');

				PROJECT.scroll.sr.reveal( '.revealFromBottomDelayed', {

					delay: 350,
					viewFactor: 0,

				});

				PROJECT.scroll.sr.reveal( '.revealFromBottomList', {

					interval: 200

				});


				/* PROJECT.scroll.sr.reveal( '.revealFromBottomExcludeDesktop', {

					desktop: false,

				});

				PROJECT.scroll.sr.reveal( '.revealFromBottomListExcludeMobile', {

					mobile: false,
					delay: 300,
					interval: 200

				}); */

				PROJECT.scroll.sr.reveal( '.revealFromLeft', {

					origin: 'left'

				});

				PROJECT.scroll.sr.reveal( '.revealFromRight', {

					origin: 'right'

				});

				PROJECT.scroll.sr.reveal( '.revealFromRightList', {

					origin: 'right',
					interval: 200

				});

				PROJECT.scroll.sr.reveal( '.revealFade', {

					distance: '0px',
					easing: 'linear',
					duration: 600,
					delay: 0

				});

				PROJECT.scroll.sr.reveal( '.wysiwyg quote', {

					origin: 'left'
					
				});

			},

			reset: function() {

				var triggers = ScrollTrigger.getAll();

				triggers.forEach( trigger => {

					trigger.kill();

				});

				PROJECT.scroll.init();

			},

			addHorzCards: function() {

				if ( $( '.jsCardsHorzCards' ).length ) {

					const slider = document.querySelector('.jsCardsHorzCards');
					let isDown = false;
					let startX;
					let scrollLeft;

					slider.addEventListener('mousedown', (e) => {

						isDown = true;
						
						slider.classList.add('active');
						
						startX = e.pageX - slider.offsetLeft;
						scrollLeft = slider.scrollLeft;

					});

					slider.addEventListener('mouseleave', () => {
						isDown = false;
						slider.classList.remove('active');
					});

					slider.addEventListener('mouseup', (e) => {
						if( isDown ) {

							e.preventDefault();

							isDown = false;
							slider.classList.remove('active');
						}
					});

					slider.addEventListener('mousemove', (e) => {
						
						if(!isDown) return;
						
						e.preventDefault();
						
						const x = e.pageX - slider.offsetLeft;
						const walk = (x - startX) * 3; //scroll-fast

						slider.scrollLeft = scrollLeft - walk;
						console.log(walk);

					});

				
						
					$( '.jsCardsHorzCards' ).on( 'wheel', function( e ) {

						if ( e.originalEvent.deltaY != 0 ) {

							e.preventDefault();

							slider.scrollLeft += e.originalEvent.deltaY;						

						}

					} );
				}


				// let hzCardsScrollPrev = 0;

				// let hzCardsScrollEls = gsap.utils.toArray( '.jsCardsHorzScrollEl' );

				// let hzCardsScrollTotal = hzCardsScrollEls.length;
				// let hzCardsScrollI = 1;

				// hzCardsScrollEls.forEach( ( hzCardsScrollEl ) => {
					
				// 	let hzCardsScrollCardRef = $( hzCardsScrollEl ).data( 'horz-scroll' );

				// 	let hzCardsScrollCard = $( '[data-horz-card="' + hzCardsScrollCardRef + '"]' );
					
				// 	let hzCardsScrollPos = $( hzCardsScrollCard ).position();
				// 	let hzCardsScrollLeft = Math.round( hzCardsScrollPos.left );

				// 	let hzCardsScrollLeftRelative = ( hzCardsScrollLeft - hzCardsScrollPrev ) + 25;
					
				// 	hzCardsScrollPrev = hzCardsScrollLeft;

				// 	$( hzCardsScrollCard ).get( 0 ).setAttribute( 'data-horz-offset', hzCardsScrollLeftRelative );

				// 	gsap.timeline({

				// 		scrollTrigger: {

				// 			trigger: hzCardsScrollEl,
				// 			start: "top bottom",
				// 			end: "bottom bottom",
				// 			scrub: true,
				// 			ease: Linear.none,

				// 			/* markers: {startColor: "red", endColor: "green", fontSize: "18px", fontWeight: "bold", indent: 20}, */

				// 			onLeave: self => {

				// 				let hzCardsScrollCardRef = $( self.trigger ).data( 'horz-scroll' );
				// 				let hzCardsScrollCard = $( '[data-horz-card="' + hzCardsScrollCardRef + '"]' );
								
				// 				$( hzCardsScrollCard ).addClass( 's-cards-horz__card--end' );

				// 			},

				// 			onEnterBack: self => {

				// 				let hzCardsScrollCardRef = $( self.trigger ).data( 'horz-scroll' );
				// 				let hzCardsScrollCard = $( '[data-horz-card="' + hzCardsScrollCardRef + '"]' );
								
				// 				$( hzCardsScrollCard ).removeClass( 's-cards-horz__card--end' );

				// 			},

				// 		}

				// 	})
				// 	.to( $( hzCardsScrollCard ).get( 0 ), {

				// 		marginLeft: ( hzCardsScrollLeftRelative * -1 ),
				// 		ease: "none",

				// 	} );

				// 	hzCardsScrollI++;

				// });

			}

		},

		header: {

			init: function() {

				PROJECT.header.getHeight( '.jsSiteHeader','--header-site-height');

				window.onresize = function() {

					PROJECT.header.getHeight( '.jsSiteHeader','--header-site-height');

				}

			},

			getHeight: function( targetClass,cssVariable ) {

				var $this = $(targetClass);

				if( $this.length > 0 ) {

					$( 'html' ).css( cssVariable,$this.height());

				}

			}

		},

		lottie: {
			
			animations: new Map(), // store animations per container

			init: function() {
				PROJECT.lottie.withObserver();
			},

			setUp: function(container, path) {
				const animation = lottie.loadAnimation({
					container: container,
					renderer: 'svg',
					loop: false,
					autoplay: false, // load but don't play yet
					path: path,
					speed: 100,
				});


				// Save animation instance for later control
				PROJECT.lottie.animations.set(container, animation);

				return animation;
			},

			withObserver: function() {

				const wrappers = document.querySelectorAll('.jsLottie');

				wrappers.forEach(el => {

					const lottieContainer = el.querySelector('.jsLottieContainer');

					if (!lottieContainer) return;

					const path = lottieContainer.getAttribute('data-json');

					if (!path) {
						console.warn('No data-json attribute found on', lottieContainer);
						return;
					}

					if (!PROJECT.lottie.animations.has(lottieContainer)) {
						PROJECT.lottie.setUp(lottieContainer, path);
					}

					const observer = new IntersectionObserver((entries, observer) => {

						entries.forEach(entry => {

							console.log('Current threshold:', entry.intersectionRatio);

							if (entry.isIntersecting) {
								
								const animation = PROJECT.lottie.animations.get(lottieContainer);

								if (animation.isPaused) {
									
									animation.setSpeed(2);
									animation.play();

								}

								observer.unobserve(entry.target);

							}

						});

					}, { threshold: 0.35 });

					observer.observe(lottieContainer);

				});

			},

		},

		stacking: {

			init: function () {
				this.initStackingCards('.jsStackingCards', '.jsStackingCardsItem', {
					useScaleScrolling: true,
					disableStacking: true,
					useOpacityScrolling: true,
					breakPoint: '0px',
				});
			},

			initStackingCards: function (containerSelector, itemSelector, options = {}) {

				function StackCards(container, itemSelector, options = {}) {
					this.element = container;
					this.items = container.querySelectorAll(itemSelector);
					this.itemSelector = itemSelector;
					this.useScaleScrolling = options.useScaleScrolling !== false; // default: true
					this.disableStacking = options.disableStacking === true;      // default: false
					this.useOpacityScrolling = options.useOpacityScrolling !== false;
					this.breakPoint = options.breakPoint ? options.breakPoint : '0px';      // default: false
					this.scrollingFn = null;
					this.scrolling = false;

					this.init();
				}

				StackCards.prototype.init = function () {
					this.setStackCards();
					this.initResizeObserver();
					this.initIntersectionObserver();
				};

				StackCards.prototype.setStackCards = function () {

					this.marginY = getComputedStyle(this.element).getPropertyValue('--stack-cards-gap');
					this.convertMarginToPx();
					this.elementHeight = this.element.offsetHeight;

					if (!this.items.length) return;

					const cardStyle = getComputedStyle(this.items[0]);
					this.cardTop = parseFloat(cardStyle.getPropertyValue('top')) || 0;
					this.cardHeight = parseFloat(cardStyle.getPropertyValue('height')) || 0;
					this.windowHeight = window.innerHeight;

					// Always apply bottom padding to create visual space
					this.element.style.paddingBottom = isNaN(this.marginY)
						? '0px'
						: (this.marginY * (this.items.length - 1)) + 'px';


					if( this.disableStacking ) {

						this.element.style.marginBottom = isNaN(this.marginY)
							? '0px'
							: (this.marginY * -(this.items.length)) + 'px';

					}

					// Always apply spacing offset
					for (let i = 0; i < this.items.length; i++) {
						if (this.disableStacking) {
							// Use margin for spacing instead of transform
							this.items[i].style.marginBottom = `${this.marginY}px`;
							this.items[i].style.transform = `scale(1)`;
							this.items[i].style.opacity = 1;
						} else {
							// Use transform for stacking effect
							const offsetY = this.marginY * i;
							this.items[i].style.marginBottom = `0px`;
							this.items[i].style.transform = `translateY(${offsetY}px) scale(1)`;
							this.items[i].style.opacity = 1;
						}
					}

				};

				StackCards.prototype.convertMarginToPx = function () {
					const testDiv = document.createElement('div');
					testDiv.style.cssText = `opacity:0;visibility:hidden;position:absolute;height:${this.marginY}`;
					this.element.appendChild(testDiv);
					this.marginY = parseInt(getComputedStyle(testDiv).getPropertyValue('height'));
					this.element.removeChild(testDiv);
				};

				StackCards.prototype.initIntersectionObserver = function () {

					const observer = new IntersectionObserver(entries => {
						if (entries[0].isIntersecting) {
							if (!this.scrollingFn) this.startScrollListener();
						} else {
							if (this.scrollingFn) {
								window.removeEventListener('scroll', this.scrollingFn);
								this.scrollingFn = null;
							}
						}
					}, { threshold: [0, 1] });

					observer.observe(this.element);

				};

				StackCards.prototype.startScrollListener = function () {

					this.scrollingFn = this.onScroll.bind(this);
					window.addEventListener('scroll', this.scrollingFn);
				};

				StackCards.prototype.onScroll = function () {
					if (this.scrolling) return;
					this.scrolling = true;
					window.requestAnimationFrame(this.animate.bind(this));
				};

				StackCards.prototype.animate = function () {

					if (isNaN(this.marginY)) {
						this.scrolling = false;
						return;
					}

					const top = this.element.getBoundingClientRect().top;
					const total = this.items.length;

					for (let i = 0; i < total; i++) {
						let scale = 1;

						var scrolling = this.cardTop - top - i * (this.cardHeight + this.marginY);

						if (this.useScaleScrolling && window.matchMedia('(min-width:' + this.breakPoint + '').matches) {
					
							if (scrolling > 0) {

								scale = i === this.items.length - 1 ? 1 : (this.cardHeight - scrolling * 0.050) / this.cardHeight;
							}

							if(total === (i + 1) ) {

								scale = 1

							}

						}

						let opacity = 1;

						if (this.useOpacityScrolling && i !== total - 1) { 
							if (scrolling > 0) {
								let fadeDistance = this.cardHeight + this.marginY * 1; // adjust multiplier for slower fade
								let scrollProgress = Math.min(scrolling / fadeDistance, 1);
								opacity = 1 - scrollProgress * 0.5;

								if( opacity === 0.5 ) {

									opacity = 0;

								}

							}
						}

						if (this.disableStacking) {
							// No stacking: use margin to separate items
							this.items[i].style.marginBottom = `${this.marginY}px`;
							this.items[i].style.transform = `scale(${scale})`;
							this.items[i].style.opacity = opacity;
						} else {
							const offsetY = this.marginY * i;
							this.items[i].style.marginBottom = `0px`; // reset margin
							this.items[i].style.transform = `translateY(${offsetY}px) scale(${scale})`;
							this.items[i].style.opacity = opacity;
						}
					}

					this.scrolling = false;

				};


				StackCards.prototype.initResizeObserver = function () {
					this.element.addEventListener('resize-stack-cards', () => {
						if (window.matchMedia('(min-width:' + this.breakPoint + '').matches) {
							this.setStackCards();
						} else {
							this.reset();
						}
					});
				};

				StackCards.prototype.reset = function () {

					for (let i = 0; i < this.items.length; i++) {
						this.items[i].style.transform = 'none';
					}

				};

				// Initialize all containers
				const containers = document.querySelectorAll(containerSelector);
				const instances = [];

				if (
					'IntersectionObserver' in window &&
					'IntersectionObserverEntry' in window &&
					'intersectionRatio' in window.IntersectionObserverEntry.prototype
				) {
				containers.forEach(container => {
					const instance = new StackCards(container, itemSelector, options);
					instances.push(instance);
				});

				const resizeEvent = new CustomEvent('resize-stack-cards');
				let resizeTimer = null;

				window.addEventListener('resize', function () {
					clearTimeout(resizeTimer);
					resizeTimer = setTimeout(() => {
					instances.forEach(instance => {
						instance.element.dispatchEvent(resizeEvent);
					});
					}, 500);
				});
				}
			}

		},

		agenda: {

			init: function() {

				PROJECT.agenda.daysNavDrag();
				PROJECT.agenda.dateSessionToggle();
				PROJECT.agenda.filersNavDrag();
				PROJECT.agenda.sessionFilters();
				PROJECT.agenda.sessionsAccordions();

			},

			daysNavDrag: function() {

				const sliders = document.querySelectorAll('.jsNavScroll');
				sliders.forEach((el) => {

					const slider = new NavDrag(el, { 
						
						dragThreshold: 10,

					 });

				});

			},

			dateSessionToggle: function() {

				const sections = document.querySelectorAll('.jsAgendaSection');

				sections.forEach(section => {

					const toggle = new ToggleSection(section,{
						triggersClass: '.jsAgendaDates',
						triggerClass: '.jsAgendaDate',
						targetsClass: '.jsAgendaSessions',
						targetClass: '.jsAgendaSession',
						dataAttr: 'data-agenda-date',
					})

					toggle.on('change', ({ event, trigger, triggerId, instance }) => {

						const parent = trigger.closest('.jsAgendaSection');
					
						if (!parent) return;
						
						// Reset filterNav
						(() => {
					
							const filterNav = parent.querySelector('.s-agenda__session.active .jsFilterNav');
					
							if (!filterNav) return;
					
							if (!filterNav.sliderInstance) return;
					
							filterNav.sliderInstance.reset();
					
						})(parent);

						// Reset filters
						(() => {
					
							const filters = parent.querySelectorAll('.jsSessionFilter');
					
							if (!filters) return;

							filters.forEach(el => {

								if( !el.filterInstance ) return false;

								el.filterInstance.reset();
								
							});
					
						})(parent);

						//Reset sectionAccordions
						(() => {
					
							const accordions = parent.querySelectorAll('.jsAccordion');
					
							if (!accordions) return;

							accordions.forEach(el => {
								
								if (!el.accordionInstance) return;

								el.accordionInstance.reset();
								
							});
					
						})(parent);
					
					});
					

				});

			},

			filersNavDrag: function() {

				const sliders = document.querySelectorAll('.jsFilterNav');
				sliders.forEach((el) => {

					const slider = new NavDrag(el, { 
						
						dragThreshold: 10,

					 });

					 el.sliderInstance = slider;

				});

			},

			sessionFilters: function() {

				const filters = document.querySelectorAll('.jsSessionFilter');

				filters.forEach(el => {

					const filter = new HideFilter(el,{
						triggersClass: '.jsSessionFilterTriggers',
						triggerClass: '.jsSessionFilterTrigger',
						targetsClass: '.jsSessionFilterTargets',
						targetClass: '.jsSessionFilterTarget',
						dataAttr: 'data-filter',
					})

					el.filterInstance = filter;

				});


			},

			sessionsAccordions:function() {

				const accordions = document.querySelectorAll('.jsAccordionSession');

				accordions.forEach(el => {

					const accordion = new Accordion(el);
					el.accordionInstance = accordion;

				});
				
			}			 

		},
		
	};

	var UTIL = {

		exec: function (controller, action) {

			var ns = PROJECT;
			action = (action === undefined) ? 'init' : action;

			if (controller !== '' && ns[controller] && typeof ns[controller][action] === 'function') {

				ns[controller][action]();

			}

		},

		init: function () {

			var body = document.body,
				controller = body.getAttribute('data-controller'),
				action = body.getAttribute('data-action');

			UTIL.exec('common');
			UTIL.exec(controller);
			UTIL.exec(controller, action);

		}

	};

	//$.PROJECT = PROJECT; // Make global available

	$(window).ready(UTIL.init);

});


